<template>
  <div class="pa-5">
    <v-row v-if="loading">
      <v-col rows="12">
        <p style="width: 100%; text-align: center;">
          <v-icon>fas fa-spinner fa-spin</v-icon> Carregando ...
        </p>
      </v-col>
    </v-row>
    <div v-else class="pa-2">
      <p class="text-center display-2">Gerenciador de links</p>
      <v-btn color="success" @click="openDialogConversion()"
        >Nova conversão</v-btn
      >
      <v-btn color="warning" @click="dialogs.params = true">Parametros</v-btn>
      <v-btn color="warning" @click="dialogs.integrations = true"
        >Integrações</v-btn
      >
      <p class="title">Histórico</p>
      <template>
        <v-data-table
          style="cursor: pointer;"
          :headers="history.headers"
          :items="history.conversions"
          item-key="id"
          class="elevation-1"
          @click:row="showConverted"
        ></v-data-table>
      </template>
    </div>
    <v-dialog v-model="dialogs.conversion" persistent max-width="1000">
      <v-card>
        <v-card-title class="headline">Nova conversão de links</v-card-title>
        <v-card-text>
          <template>
            <v-stepper v-model="stepNewCreation">
              <v-stepper-header>
                <v-stepper-step :complete="stepNewCreation > 1" step="1">
                  Adicionar links
                  <small>Paste yout content here</small>
                </v-stepper-step>
                <v-stepper-step :complete="stepNewCreation > 2" step="2"
                  >Integrações</v-stepper-step
                >
                <v-stepper-step :complete="stepNewCreation > 3" step="3"
                  >Confirmação</v-stepper-step
                >
                <v-stepper-step :complete="stepNewCreation > 4" step="4"
                  >Conversão</v-stepper-step
                >
              </v-stepper-header>

              <v-stepper-content step="1">
                <div v-if="extractingLinks.executing">
                  <p style="width: 100%; text-align: center;">
                    <v-icon>fas fa-spinner fa-spin</v-icon> Extraindo links
                    {{ extractingLinks.currentLink }} ...
                  </p>
                  <v-progress-linear
                    :value="extractingLinks.progress"
                  ></v-progress-linear>
                </div>
                <v-textarea
                  :disabled="
                    extractingLinks.executing || conversionProgress
                      ? true
                      : false
                  "
                  class="mt-2"
                  outlined
                  no-resize
                  rows="18"
                  name="input-7-4"
                  label="Raw links"
                  value=""
                  color="red"
                  v-model="links.text_source"
                ></v-textarea>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-select
                  v-model="linkIntegration"
                  :items="linkIntegrations"
                  item-text="name"
                  item-value="id"
                  label="Integração para encurtar os links"
                  clearable
                ></v-select>
                <v-select
                  v-model="ruleIntegration"
                  :items="ruleIntegrations"
                  item-text="name"
                  item-value="id"
                  label="Integração de geração de links"
                  clearable
                ></v-select>
                <div class="text-right">
                  <v-btn
                    color="warning"
                    :disabled="fetchingTags"
                    @click="openAddTags()"
                    >Adicionar TAG
                    <v-icon class="ml-2">fas fa-plus</v-icon></v-btn
                  >
                </div>
                <v-switch
                  v-model="uriEncode"
                  :label="`URI Encode: ${uriEncode.toString()}`"
                ></v-switch>
              </v-stepper-content>

              <v-stepper-content step="3">
                <div class="text-right">
                  <v-btn color="error" @click="clearParams()"
                    >Limpar todos os parametros<v-icon class="ml-2"
                      >fas fa-times</v-icon
                    >
                  </v-btn>
                </div>

                <div v-for="(link, ixlnk) in links.urls" :key="ixlnk">
                  <p class="title mb-0">
                    Link{{ ixlnk }}: <b>{{ link.extracted.host }}</b>
                  </p>
                  <p class="subtitle-2">
                    {{
                      `${link.extracted.concatBefore || ''}${
                        link.extracted.urlWithParams
                      }${link.extracted.concatAfter || ''}`
                    }}
                  </p>
                  <v-btn
                    color="success"
                    @click="
                      link.extracted.params[
                        promptVal('Nome do parametro da URL')
                      ] = null
                      $forceUpdate()
                    "
                    ><v-icon class="mr-2">fas fa-plus</v-icon> Add</v-btn
                  >
                  <v-btn
                    class="ml-2"
                    color="warning"
                    @click="clearParams(ixlnk)"
                    ><v-icon class="mr-2">fas fa-times</v-icon> Remover
                    parametros</v-btn
                  >
                  <v-row v-if="link.extracted.params">
                    <v-col
                      v-for="(par, ix) in link.extracted.params"
                      :key="link.extracted.host + ix"
                    >
                      <v-text-field
                        v-model="link.extracted.params[ix]"
                        :label="ix"
                        @change="$forceUpdate()"
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                </div>
              </v-stepper-content>

              <v-stepper-content step="4">
                <v-textarea
                  id="text-area-text_converted"
                  :disabled="conversionProgress ? true : false"
                  class="mt-2"
                  outlined
                  no-resize
                  rows="18"
                  name="input-7-4"
                  label="Converted links"
                  value="lista de urls convertidas aqui"
                  color="green"
                  readonly=""
                  v-model="links.text_converted"
                ></v-textarea>
                <v-btn
                  color="success"
                  @click="copyTestingCode('text-area-text_converted')"
                  ><v-icon class="mr-2">fas fa-copy</v-icon> Copiar</v-btn
                >

                <div v-if="conversionProgress">
                  <p style="width: 100%; text-align: center;">
                    <v-icon>fas fa-spinner fa-spin</v-icon> Convertendo ...
                  </p>
                  <v-progress-linear
                    :value="conversionProgress"
                  ></v-progress-linear>
                </div>
              </v-stepper-content>
            </v-stepper>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div v-if="!links.text_converted">
            <v-btn
              :disabled="conversionProgress ? true : false"
              color="red darken-1"
              text
              @click="dialogs.conversion = false"
              >Cancel</v-btn
            >
            <v-btn
              :disabled="
                conversionProgress || stepNewCreation <= 1 ? true : false
              "
              color="blue darken-1"
              text
              @click="stepNewCreation -= 1"
              >Voltar</v-btn
            >
            <v-btn
              :disabled="
                conversionProgress || extractingLinks.executing ? true : false
              "
              color="green darken-1"
              text
              @click="fakeprogress()"
            >
              <span v-if="stepNewCreation < 3">Continuar</span>
              <span v-else>Converter</span>
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              :disabled="conversionProgress ? true : false"
              color="red darken-1"
              text
              @click="closeConversion()"
              ><v-icon class="mr-2">fas fa-times</v-icon> Fechar</v-btn
            >
            <v-btn
              :disabled="conversionProgress ? true : false"
              color="blue darken-1"
              text
              @click="saveConversion()"
              ><v-icon class="mr-2">fas fa-save</v-icon> Salvar resultado</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogs.viewConverted">
      <v-card>
        <v-card-title class="headline"
          >Visualizar dados convertidos</v-card-title
        >
        <v-card-text>
          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="6">
              <v-textarea
                id="text-area-history-text_source"
                v-model="historySource"
                outlined
                no-resize
                rows="18"
                name="input-7-4"
                label="Raw links"
                color="red"
                readonly=""
              ></v-textarea>
              <v-btn
                color="warning"
                @click="copyTestingCode('text-area-history-text_source')"
                ><v-icon class="mr-2">fas fa-copy</v-icon> Copiar</v-btn
              >
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              <v-textarea
                id="text-area-history-text_converted"
                v-model="historyConverted"
                outlined
                no-resize
                rows="18"
                name="input-7-4"
                label="Converted links"
                color="green"
                readonly=""
              ></v-textarea>
              <v-btn
                color="success"
                @click="copyTestingCode('text-area-history-text_converted')"
                ><v-icon class="mr-2">fas fa-copy</v-icon> Copiar</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogs.viewConverted = false"
            >Voltar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.params" persistent max-width="1200">
      <v-card>
        <my-params
          @saveParams="
            _nCfg => {
              this.config = _nCfg
              this.dialogs.params = false
            }
          "
          @close="dialogs.params = false"
        />
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.integrations" persistent max-width="1200">
      <v-card>
        <my-integrations
          @saveIntegrations="
            _nInt => {
              this.integrations = _nInt
              this.dialogs.integrations = false
            }
          "
          @close="dialogs.integrations = false"
        />
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.addTag" max-width="600px">
      <v-card>
        <v-card-title class="headline">Adicionar tag aos links</v-card-title>
        <v-card-text>
          <v-row align="center">
            <v-col class="d-flex" cols="12">
              <v-select
                :disabled="fetchingTags"
                :items="tags"
                v-model="linksTag"
                item-text="value"
                label="Seleciona uma TAG"
              ></v-select>
            </v-col>
            <v-col class="d-flex" cols="6">
              <v-text-field
                :disabled="fetchingTags"
                v-model="linksTag"
                label="Tag personalizada (não esqueça de colocar tag=valor)"
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="6">
              <v-btn
                :disabled="fetchingTags"
                color="green"
                @click="saveNewTag(linksTag)"
                ><v-icon>fas fa-save</v-icon></v-btn
              >
              <v-btn
                :disabled="fetchingTags"
                color="error"
                @click="removeTag(linksTag)"
                ><v-icon>fas fa-times</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="applyTag(linksTag)"
            >Aplicar em todos os links</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import f from './../scripts/functions'
import URL_INFO from './../class/url_info'
import URL from './../class/url'
import Parametros from './Parametros'
import Integrations from './Integrations'
export default {
  components: {
    'my-params': Parametros,
    'my-integrations': Integrations
  },
  data() {
    return {
      uriEncode: true,
      allPERFECT: false,
      maxTrials: 3,
      $bearer: null,
      historySource: null,
      tags: [],
      extractingLinks: {
        executing: false,
        currentLink: '',
        progress: 0
      },
      fetchingTags: false,
      historyConverted: null,
      myFrame: null,
      linksTag: null,
      parameterTypes: [
        { id: 0, text: 'PARAMETRO' },
        { id: 1, text: 'CAMINHO' },
        // { id: 2, text: 'Zanox (integração)' },
        { id: 3, text: 'Awin (integração)' }
      ],
      rules: [
        { id: 0, text: 'Ignorar a regra atual' },
        { id: 1, text: 'Substituir pelo valor atual' },
        { id: 2, text: 'Excluir parametro do link' }
      ],
      newParameterRule: [
        {
          id: 0,
          text:
            'Manter todos os eventuais parametros que não estiverem listados'
        },
        {
          id: 1,
          text:
            '[Whitelist] Manter somente os parametros aqui listados e remover os novos'
        }
      ],
      stepNewCreation: 1,
      conversionProgress: null,
      links: {
        text_source: '',
        text_converted: '',
        urls: [],
        source: '',
        extracted: [],
        redirected: [],
        converted: null
      },
      dialogs: {
        conversion: null,
        viewConverted: null,
        params: null,
        integrations: null,
        addTag: null
      },
      history: {
        headers: [
          { text: 'Data', value: 'date' },
          { text: 'Links', value: 'count' }
        ],
        conversions: []
      },
      config: {},
      ruleIntegration: null,
      ruleIntegrations: [],
      linkIntegration: null,
      linkIntegrations: [],
      integrations: [],
      loading: true,
      f: f
    }
  },
  created() {
    var vm = this
    vm.prepareAPP()
  },
  mounted() {},
  methods: {
    prepareAPP(_tryal = 0) {
      var vm = this
      _tryal += 1
      if (_tryal <= vm.maxTrials) {
        if (_tryal > 1) {
          vm.$snotify.warning(
            `[TENTATIVA ${_tryal}/${vm.maxTrials}] Cosnultando configurações`
          )
        }
        vm.fetchMe()
          .then(_cfg => {
            vm.config = _cfg
            // vm.$snotify.success(`Configurações carregadas!`)
            vm.fetchHistory()
              .then(() => {
                vm.loading = false
                vm.allPERFECT = true
                // vm.$snotify.success(`Histórico carregado!`)
                // vm.$snotify.success(`APP pronta para uso!`)
              })
              .catch(error => {
                vm.loading = false
                vm.allPERFECT = false
                vm.$snotify.error(
                  `[TENTATIVA ${_tryal}/${vm.maxTrials}] Erro ao listar o histórico: ${error.message}`
                )
                vm.prepareAPP(_tryal)
              })
          })
          .catch(error => {
            vm.loading = false
            vm.allPERFECT = false
            vm.$snotify.error(
              `[TENTATIVA ${_tryal}/${vm.maxTrials}] Erro ao consultar configurações: ${error.message}`
            )
            vm.prepareAPP(_tryal)
          })
      } else {
        vm.$snotify.error(
          `[TENTATIVA ${vm.maxTrials}] Número máximo de tentatias atingido e não foi possível preparar as configurações. Atualize a página.`
        )
      }
    },
    openDialogConversion() {
      var vm = this
      if (vm.allPERFECT) {
        vm.dialogs.conversion = true
      } else {
        vm.$snotify.warning(`Não foi possível inicializar os parametros`)
        vm.prepareAPP()
      }
    },
    getRuleIntegrations() {
      var vm = this
      vm.ruleIntegration = null
      vm.ruleIntegrations = []
      if (vm.integrations) {
        vm.integrations.forEach(int => {
          if (int.type < 2) {
            vm.ruleIntegrations.push(int)
          }
        })
      }
    },
    getLinkIntegrations() {
      var vm = this
      vm.linkIntegration = null
      vm.linkIntegrations = []
      if (vm.integrations) {
        vm.integrations.forEach(int => {
          if (int.type == 2) {
            vm.linkIntegrations.push(int)
            vm.linkIntegration = int.id
          }
        })
      }
    },
    copyTestingCode(_elementID) {
      var vm = this
      let testingCodeToCopy = document.querySelector(`#${_elementID}`)
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        if (document.execCommand('copy')) {
          vm.$snotify.success(`Texto copiado para a área de transferência`)
        } else {
          throw new Error(
            'Não foi possível copiar o texto para área de transferência. Copie manualmente'
          )
        }
      } catch (_err) {
        vm.$snotify.error(`Oops... ${_err.message}`)
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    async getLastRedirect(_urlSource) {
      var vm = this
      let _result = ''
      await vm.$API
        .Request('put', 'conversion/lastRedirect', { url: _urlSource })
        .then(result => {
          _result = result.data
        })
        .catch(error => {
          _result = error
        })
      if (_result.url) {
        let _url = new URL()
        _url.url = _result.url
        _url.host = _result.host
        return _url
      } else {
        return null
      }
    },
    saveParams() {
      var vm = this
      vm.$API
        .Request('put', 'setConfig', { data: JSON.stringify(vm.config) })
        .then(result => {
          console.debug(result.data)
          vm.$snotify.success(`Configurações salvas com sucesso`)
          vm.dialogs.params = false
        })
        .catch(error => {
          vm.$snotify.error(`Erro ao salvar configurações: ${error.message}`)
          console.debug(error)
        })
    },
    saveConversion() {
      var vm = this
      console.debug(vm.links)
      vm.$API
        .Request('put', 'conversion/new', { source: JSON.stringify(vm.links) })
        .then(result => {
          console.debug(result.data)
          // #########################################################
          // TODO2: Colocar em um objeto LINK
          //          let _cvn = result.data
          //          let _src = JSON.parse(_cvn.source)
          //          let _conversion = {
          //            id: _cvn.id,
          //            date: _cvn.created_at,
          //            data: {
          //              text_source: _src.text_source,
          //              text_converted: _src.text_converted,
          //              urls: _src.urls
          //            }
          //          }
          //          _conversion.count = _conversion.data.urls
          //            ? _conversion.data.urls.length
          //            : 0
          //          vm.history.conversions.unshift(_conversion)
          // #########################################################
          vm.fetchHistory()
          vm.stepNewCreation = 1
          vm.links.text_source = ''
          vm.links.text_converted = null
          vm.dialogs.conversion = false
          vm.$snotify.success(`Conversão salva com sucesso`)
        })
        .catch(error => {
          vm.$snotify.error(`Erro ao salvar conversão: ${error.message}`)
          console.debug(error)
        })
    },
    closeConversion() {
      var vm = this
      vm.fetchHistory()
      vm.dialogs.conversion = false
      vm.stepNewCreation = 1
      vm.links.text_source = ''
      vm.links.text_converted = null
      // vm.$snotify.success(`Conversão salva com sucesso`)
    },
    openAddTags() {
      var vm = this
      vm.fetchTags().then(() => {
        vm.dialogs.addTag = true
      })
    },
    fetchTags() {
      var vm = this
      vm.tags = []
      vm.fetchingTags = true
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('get', `tag/list`)
          .then(result => {
            if (result && result.data) {
              vm.tags = result.data
            }
            vm.fetchingTags = false
            resolve(true)
          })
          .catch(error => {
            vm.$snotify.error(`Erro ao consultar integrações: ${error.message}`)
            vm.fetchingTags = false
            reject(error)
          })
      })
    },
    applyTag(_tag) {
      var vm = this
      try {
        vm.links.urls.forEach(_url => {
          _url.extracted.addParam(_tag)
        })
        vm.$snotify.success(`Tags aplicadas com sucesso`)
      } catch (error) {
        vm.$snotify.error(`Erro ao aplicar tags: ${error.message}`)
      }

      vm.dialogs.addTag = false
    },
    saveNewTag(_tag) {
      var vm = this
      vm.fetchingTags = true
      vm.$API
        .Request('post', `tag/new`, { tag: _tag })
        .then(result => {
          console.debug(result)
          vm.$snotify.success(`Nova tag salva com sucesso`)
          vm.fetchTags()
        })
        .catch(error => {
          vm.$snotify.error(
            `Não foi possível slavar a nova tag: ${error.message}`
          )
          vm.fetchingTags = false
        })
    },
    removeTag(_tag) {
      var vm = this
      vm.fetchingTags = true
      vm.$API
        .Request('post', `tag/remove`, { tag: _tag })
        .then(result => {
          console.debug(result)
          vm.$snotify.success(`Tag removida com sucesso`)
          vm.fetchTags()
        })
        .catch(error => {
          vm.$snotify.error(`Não foi possível remover tag: ${error.message}`)
          vm.fetchingTags = false
        })
    },
    fetchMe() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('get', `me`)
          .then(result => {
            if (result && result.configurations) {
              if (result.configurations.link_rules) {
                resolve(JSON.parse(result.configurations.link_rules))
              }
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchIntegrations() {
      var vm = this
      vm.integrations = []
      vm.ruleIntegration = null
      vm.ruleIntegrations = []
      vm.linkIntegration = null
      vm.linkIntegrations = []
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('get', `integration/list`)
          .then(result => {
            if (result && result.data) {
              vm.integrations = result.data
            }
            vm.getRuleIntegrations()
            vm.getLinkIntegrations()
            console.debug(result)
            resolve(true)
          })
          .catch(error => {
            vm.$snotify.error(`Erro ao consultar integrações: ${error.message}`)
            console.debug(error)
            reject(error)
          })
      })
    },
    fetchHistory() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('get', `conversion/list`)
          .then(result => {
            if (result && result.data) {
              vm.history.conversions = []
              result.data.forEach(_cvn => {
                // TODO2: Colocar em um objeto LINK
                let _src = JSON.parse(_cvn.source)
                let _conversion = {
                  id: _cvn.id,
                  date: _cvn.created_at,
                  data: {
                    text_source: _src.text_source,
                    text_converted: _src.text_converted,
                    urls: _src.urls
                  }
                }
                _conversion.count = _conversion.data.urls
                  ? _conversion.data.urls.length
                  : 0
                vm.history.conversions.push(_conversion)
              })
            }
            resolve(true)
          })
          .catch(error => {
            vm.$snotify.error(
              `Erro ao consultar configurações: ${error.message}`
            )
            console.debug(error)
            reject(error)
          })
      })
    },
    backStep() {
      var vm = this
      if (vm.stepNewCreation > 1) {
        vm.stepNewCreation -= 1
      }
    },
    promptVal(_text) {
      return window.prompt(_text)
    },
    async extractLinks() {
      var vm = this
      let _urlsFromText = f.GetLinksFromText(vm.links.text_source)
      if (!_urlsFromText || _urlsFromText.length == 0) {
        vm.$snotify.error(`Nenhuma URL válida encontrada no texto!`)
        throw new Error('Nenhuma URL válida encontrada no texto')
      }
      vm.extractingLinks.executing = true
      vm.links.urls = []
      _urlsFromText.forEach(_url => {
        vm.links.urls.push(new URL_INFO({ source: _url }))
      })

      for (let _ixLnk = 0; _ixLnk < vm.links.urls.length; _ixLnk++) {
        const _LINK = vm.links.urls[_ixLnk]
        vm.extractingLinks.currentLink = _LINK.source.url
        vm.extractingLinks.progress = (_ixLnk * 100) / vm.links.urls.length
        let _lnkRedirected = await vm.getLastRedirect(_LINK.source.url)
        if (!_lnkRedirected) {
          continue
        } // At this point, ignore the following tasks if can't find the object
        _LINK.extracted = _lnkRedirected

        for (let _ix in vm.config.domains) {
          if (_lnkRedirected.url.indexOf(vm.config.domains[_ix].domain) > -1) {
            let _params = _LINK.extracted.params // GET params from the extracted link
            // It could merge the params from the source too... but not for now!
            if (vm.config.domains[_ix].newParameterRule === 1) {
              // overwrite all params
              _params = {}
            }
            vm.config.domains[_ix].parameters.forEach(_dPar => {
              if (_dPar.type === 0) {
                // URL Parameter rules
                switch (_dPar.rule) {
                  case 0: // Ignorar a regra atual
                    break
                  case 1: // Substituir pelo valor atual
                    _params[_dPar.name] = _dPar.value
                    break
                  case 2: // Excluir parametro do link
                    if (_params[_dPar.name]) {
                      delete _params[_dPar.name]
                    }
                    break
                }
              } else if (_dPar.type === 1) {
                // Change thr URL itself
                let _protMatches = _LINK.extracted.url.match(
                  /(^\w+:|^)\/\//,
                  'gm'
                )
                let _protocol =
                  _protMatches && _protMatches[0] ? _protMatches[0] : ''
                let _cleanPath = _LINK.extracted.url.replace(
                  /(^\w+:|^)\/\//,
                  ''
                )
                let _spltUrl = _cleanPath.split('/')
                if (_spltUrl && _spltUrl.length >= _dPar.order) {
                  _spltUrl[_dPar.order] = _dPar.value
                  _LINK.extracted.url = `${_protocol}${_spltUrl.join('/')}`
                }
              }
            })
            _LINK.extracted.params = _params // VERY IMPORTANT to be done after everything is already done!
            _LINK.extracted.concatBefore = vm.config.domains[_ix].concatBefore
            _LINK.extracted.concatAfter = vm.config.domains[_ix].concatAfter
            //_LINK.extracted.urlWithParams = `${_LINK.extracted.concatBefore || ''}${_LINK.extracted.urlWithParams}${_LINK.extracted.concatAfter || ''}`
            break
          }
        }
      }
      vm.extractingLinks.executing = false
      vm.extractingLinks.progress = 0
      vm.extractingLinks.currentLink = ''
    },
    async fakeprogress() {
      var vm = this
      if (vm.stepNewCreation < 3) {
        if (vm.stepNewCreation == 1) {
          vm.fetchIntegrations()
          await vm.extractLinks()
        }
        vm.stepNewCreation += 1
      } else {
        vm.stepNewCreation += 1

        // Promise ? why :D
        vm.links.text_converted = null
        let _conv = vm.links.text_source
        let _counterProgress = 1
        for (let _ixurls = 0; _ixurls < vm.links.urls.length; _ixurls++) {
          const _link = vm.links.urls[_ixurls]
          let _extractedUrlShorted = null
          try {
            let _resultJson = await vm.$API.Request(
              'put',
              'conversion/shortUrl',
              {
                url: `${_link.extracted.concatBefore || ''}${
                  _link.extracted.urlWithParams
                }${_link.extracted.concatAfter || ''}`,
                linkIntegration: vm.linkIntegration,
                ruleIntegration: vm.ruleIntegration,
                uriEncode: vm.uriEncode
              }
            )
            _extractedUrlShorted =
              _resultJson && _resultJson.data && _resultJson.data.link
                ? _resultJson.data.link
                : `${_link.extracted.concatBefore || ''}${
                    _link.extracted.urlWithParams
                  }${_link.extracted.concatAfter || ''}`
            console.debug(_resultJson)
            if (_resultJson && _resultJson.data && _resultJson.data.message) {
              vm.$snotify.error(
                'Não foi possível converter o link. Motivo: ' +
                  _resultJson.data.message
              )
            }
            if (_resultJson && _resultJson.message) {
              vm.$snotify.error(
                'Não foi possível converter o link. Motivo: ' +
                  _resultJson.message
              )
            }
          } catch (error) {
            let _msg =
              error &&
              error.response &&
              error.response.data &&
              error.response.data.message
                ? error.response.data.message
                : error.message
            vm.$snotify.error(
              `Erro ao tentar converter uma URL usando BitLy: ` + _msg
            )
            _extractedUrlShorted = `${_link.extracted.concatBefore || ''}${
              _link.extracted.urlWithParams
            }${_link.extracted.concatAfter || ''}`
          }
          _conv = _conv.replace(
            new RegExp(
              _link.source.url.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'),
              'gmi'
            ),
            _extractedUrlShorted
          )
          vm.conversionProgress =
            (_counterProgress * 100) / vm.links.redirected.length
          _counterProgress += 1
        }
        vm.conversionProgress = null
        vm.links.text_converted = _conv
      }
    },
    showConverted(_item) {
      var vm = this
      console.debug(_item)
      vm.historySource = _item.data.text_source
      vm.historyConverted = _item.data.text_converted
      vm.dialogs.viewConverted = true
    },
    clearParams(index) {
      var vm = this
      if (index != undefined) {
        vm.links.urls[index].extracted.params = []
      } else {
        vm.links.urls.forEach(link => {
          link.extracted.params = []
        })
      }
    }
  },
  computed: {}
}
</script>
